module.exports = __webpack_public_path__ + "img/logo-ecopetrol.5c8d72c4.svg";